module.exports = __webpack_public_path__ + "static/media/status_yellow.b568ba56.svg";